module.exports = __webpack_public_path__ + "static/media/ic-nav-taxation-active.f3f64403.svg";